<div class="groups-list page-layout simple inner-scroll"
  fusePerfectScrollbar>
  <app-banner-info class="groups-list__banner-info"
    [rolesCanShowBanner]="rolesCanShowBannerInfo"
    [situation]="type">
  </app-banner-info>

  @if (shouldDisplayFilters()) {
    <mat-toolbar
      class="groups-list__toolbar filters"
      [ngClass]="filtersExpanded ? 'isExpanded' : 'isCollapsed'">
      <!-- TODO : Reporter dans les autres templates ou en faire un composant -->
      <mat-toolbar-row fxLayoutGap="18px"> <!-- Ligne des filtres et Actions spéciales -->
        <ng-container> <!-- Filtres -->
          @if (displayFilter('nickname') && nicknameContextAllowed) {
            <mat-form-field
              [field]="'nickname'"
              [fields]="collapsibleFields"
              [floatLabel]="floatLabel"
              isCollapsibleField>
              <mat-label>{{ 'groups-management.filter_nickname' | translate }}</mat-label>
              <input matInput
                #nicknameInput="matInput"
                [formControl]="nicknameCtrl"
                >
              </mat-form-field>
            }
            @if (displayFilter('school') && hasField('schoolyear')) {
              <mat-form-field [field]="'school'"
                [fields]="collapsibleFields" class="field-school" isCollapsibleField>
                <mat-label>{{ 'groups-management.chose_school.year' | translate }}</mat-label>
                <mat-select (selectionChange)="applyFilterSchoolYear($event)"
                  [value]="groupsManagementService.schoolyearDefaultMatSelectValue"
                  name="schoolyear"
                  >
                  <mat-option [value]="'all'">{{ 'generic.allf' | translate }}</mat-option>
                  @for (shoolYear of groupsManagementService.schoolYearsList; track shoolYear) {
                    <mat-option
                      [value]="shoolYear.id"> {{ groupsManagementService.displaySchoolYear(shoolYear.get('name')) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (type === 'learner') {
              @if (displayFilter('workgroup')) {
                <mat-form-field [field]="'workgroup'"
                  [fields]="collapsibleFields" isCollapsibleField>
                  <mat-label>{{ 'groups-management.filter_by_workgroup' | translate }}</mat-label>
                  <mat-chip-grid #workgroupsChipList>
                    @for (workgroupChip  of workgroupsChips; track workgroupChip ) {
                      <mat-chip-row
                        (removed)="removeChip(workgroupChip, 'workgroups')"
                        (removed)="removeChip(workgroupChip, 'workgroups')"
                        [removable]="workgroupsRemovable">
                        {{ workgroupChip }}
                        @if (workgroupsRemovable) {
                          <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                        }
                      </mat-chip-row>
                    }
                    <input
                      #workgroupsChipInput
                      (matChipInputTokenEnd)="blurAllChipsList()"
                      [formControl]="workgroupsCtrl"
                      [matAutocomplete]="workgroups"
                      [matChipInputAddOnBlur]="workgroupsAddOnBlur"
                      [matChipInputFor]="workgroupsChipList"
                      [matChipInputSeparatorKeyCodes]="workgroupsSeparatorKeysCodes"
                      [matAutocompleteDisabled]="!workgroupsSelectable"
                      [ngClass]="!workgroupsSelectable?'chip-read-only':''"
                      />
                    </mat-chip-grid>
                    <mat-autocomplete #workgroups="matAutocomplete"
                      (optionSelected)="chipSelected($event, 'workgroups')">
                      @for (workgroupChip of workgroupsFilteredChips | async; track workgroupChip) {
                        <mat-option appAriaTitle
                          [value]="workgroupChip.workgroupname">
                          {{ workgroupChip.workgroupname }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                }
                @if (displayFilter('groups')) {
                  <mat-form-field [field]="'groups'" [fields]="collapsibleFields"
                    isCollapsibleField>
                    <mat-label>{{ 'groups-management.filter_by_class' | translate }}</mat-label>
                    <mat-chip-grid #groupsChipList>
                      @for (groupChip  of groupsChips; track groupChip ) {
                        <mat-chip-row
                          (removed)="removeChip(groupChip, 'groups')"
                          [removable]="groupsRemovable">
                          {{ groupChip }}
                          @if (groupsRemovable) {
                            <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                          }
                        </mat-chip-row>
                      }
                      <input
                        #groupsChipInput
                        (matChipInputTokenEnd)="blurAllChipsList()"
                        [formControl]="groupsCtrl"
                        [matAutocomplete]="groups"
                        [matChipInputAddOnBlur]="groupsAddOnBlur"
                        [matChipInputFor]="groupsChipList"
                        [matChipInputSeparatorKeyCodes]="groupsSeparatorKeysCodes"
                        [matAutocompleteDisabled]="!groupsSelectable"
                        [ngClass]="!groupsSelectable?'chip-read-only':''"
                        />
                      </mat-chip-grid>
                      <mat-autocomplete
                        appAriaTitle
                        #groups="matAutocomplete"
                        (optionSelected)="chipSelected($event, 'groups')">
                        @for (groupChip of groupsFilteredChips | async; track groupChip) {
                          <mat-option
                            [value]="groupChip.groupname">
                            {{ groupChip.groupname }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                }
                @if (displayFilter('archived') && archiveEntitySettings && authService.isAtLeastTrainer()) {
                  <ng-container
                    [field]="'archived'" [fields]="collapsibleFields" isCollapsibleField>
                    <mat-form-field>
                      <mat-label>{{ 'groups-management.show-dearchive-class' | translate }}</mat-label>
                      <mat-select
                        (selectionChange)="applyFilters($event)"
                        [(ngModel)]="defaultArchive"
                        >
                        <mat-option [value]="false">{{ 'generic.notArchived' | translate }}</mat-option>
                        <mat-option [value]="true">{{ 'generic.archived' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                }
              </ng-container>
              <ng-container> <!-- Actions Spéciales -->
                @if (canBeJoined && authService.hasLevel(['learner']) && type === 'class') {
                  <button class="groups-list__join-button"
                    (click)="joinGroup()"
                    data-e2e="group-list-join-group"
                    ariaLabelTranslate="{{ 'account-management.register' | translate }}"
                    mat-raised-button>
                    {{ 'group-management.join_class' | translate }}
                  </button>
                }
                @if (authService.hasLevel(['trainer']) && type === 'learner') {
                  @if (isImportLearnerEnabled) {
                    <button (click)="importLearners()"
                      data-e2e="group-list-import-learners"
                      ariaLabelTranslate="{{ 'group-management.import_learners' | translate }}"
                      mat-raised-button>
                      {{ 'group-management.import_learners' | translate }}
                    </button>
                  }
                  @if (isExportEnabled) {
                    <button
                      (click)="exportList()"
                      data-e2e="group-list-export-list"
                      ariaLabelTranslate="{{ 'group-management.export_list' | translate }}"
                      mat-raised-button>
                      {{ 'group-management.export_list' | translate }}
                    </button>
                  }
                }
              </ng-container>
              <!--help video button-->
              @if (displayFilter('button-video-help') && videoUrlToLaunch()!==''
                && authService.isAtLeastTrainer() && type === 'learner') {
                <button
                  (click)="playHelpVideo()"
                  [field]="'activitiesType'" [fields]="collapsibleFields" class="btn-videoUrlToLaunch"
                  color="primary"
                  data-e2e="group-list-play-help-video"
                  isCollapsibleField mat-raised-button>
                  {{ 'generic.lessons.video.help' | translate }}
                </button>
              }
              @if (videoUrlToLaunch()!=='' && authService.isAtLeastTrainer() && type === 'learner') {
                <button (click)="playHelpVideo()"
                  data-e2e="group-list-play-help-video-2"
                  class="btn-videoUrlToLaunch" color="primary"
                  mat-raised-button>{{ 'generic.lessons.video.help' | translate }}
                </button>
              }
            </mat-toolbar-row>
            <mat-toolbar-row fxLayoutGap="18px">
              <!-- Eléments disponible pour la sélection -->
              @if (showMultiSelectionAction) {
                <span>{{ 'generic.for_selection' | translate }} : </span> <!-- TODO Sa place n'est pas ici mais au dessus, mais si l'on le fait il
                faut tester si au moins un bouton/une action est disponible pour l'utilisateur-->
                @if (archiveEntitySettings && !archived) {
                  <button (click)="archiveListEntity()"
                    [disabled]="isSelectionActionIsEnabled() === false"
                    aria-label="archive"
                    data-e2e="group-list-archive-entity"
                    class="groups-list__archive-button">
                    <mat-icon svgIcon="archive"></mat-icon>
                    <span>{{ 'generic.archive' | translate }}</span>
                  </button>
                }
                @if (dearchiveEntitySettings && archived) {
                  <button (click)="dearchiveListEntity()"
                    [disabled]="isSelectionActionIsEnabled() === false"
                    data-e2e="group-list-dearchive-entity"
                    aria-label="dearchive"
                    class="groups-list__unarchive-button"
                    mat-raised-button>
                    <mat-icon svgIcon="unarchive"></mat-icon>
                    <span>{{ 'generic.unarchive' | translate }}</span>
                  </button>
                }
                @if (canActiveMetacognition() && activateMetacognitionEntitySettings) {
                  <button (click)="activateMetacognitionListEntity()"
                    [disabled]="isSelectionActionIsEnabled() === false"
                    aria-label="activateMetacognition"
                    data-e2e="group-list-activate-meta-cognition"
                    mat-raised-button>
                    <mat-icon svgIcon="edit"></mat-icon>
                    <span>{{ 'generic.activateMetacognition' | translate }}</span>
                  </button>
                }
                @if (canActiveMetacognition() && deactivateMetacognitionEntitySettings) {
                  <button (click)="deactivateMetacognitionListEntity()"
                    [disabled]="isSelectionActionIsEnabled() === false"
                    data-e2e="group-list-deactivate-meta-cognition"
                    aria-label="deactivateMetacognition"
                    mat-raised-button>
                    <mat-icon svgIcon="edit"></mat-icon>
                    <span>{{ 'generic.deactivateMetacognition' | translate }}</span>
                  </button>
                }
                @if (deleteEntitySettings && deleteLearners) {
                  <button (click)="deleteListEntity()"
                    [disabled]="isSelectionActionIsEnabled() === false"
                    data-e2e="group-list-delete-list-entity"
                    aria-label="remove"
                    mat-raised-button>
                    <mat-icon svgIcon="delete"></mat-icon>
                    <span>{{ 'generic.delete' | translate }}</span>
                  </button>
                }
              }
              @if (type === 'learner') {
                @if (displayFilter('groupAssociate')) {
                  <mat-form-field [field]="'activitiesType'"
                    [fields]="collapsibleFields" isCollapsibleField>
                    <mat-label>{{ 'groups-management.associate_group' | translate }}</mat-label>
                    <mat-chip-grid #groupsAssociateChipList>
                      @for (groupChip  of groupsAssociateChips; track groupChip ) {
                        <mat-chip-row
                          (removed)="removeGroupToAssociate(groupChip)"
                          [removable]="true"
                          [selectable]="true">
                          {{ groupChip }}
                          <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                        </mat-chip-row>
                      }
                      <input
                        #groupsAssociateChipInput
                        (matChipInputTokenEnd)="blurAllChipsList()"
                        [formControl]="groupsAssociateCtrl"
                        [matAutocomplete]="groupsAssociate"
                        [matChipInputAddOnBlur]="false"
                        [matChipInputFor]="groupsAssociateChipList"
                        [matChipInputSeparatorKeyCodes]="groupsAssociateSeparatorKeysCodes"
                        />
                      </mat-chip-grid>
                      <mat-autocomplete #groupsAssociate="matAutocomplete"
                        (optionSelected)="groupToAssociateSelected($event)">
                        @for (groupChip of groupsAssociateFilteredChips | async; track groupChip) {
                          <mat-option appAriaTitle
                            [value]="groupChip.groupname">
                            {{ groupChip.groupname }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                  @if (displayFilter('workgroupAssociate')) {
                    <mat-form-field [field]="'activitiesType'"
                      [fields]="collapsibleFields" isCollapsibleField>
                      <mat-label>{{ 'groups-management.associate_workgroup' | translate }}</mat-label>
                      <mat-chip-grid #workgroupsAssociateChipList>
                        @for (workgroupChip  of workgroupsAssociateChips; track workgroupChip ) {
                          <mat-chip-row
                            (removed)="removeWorkGroupToAssociate(workgroupChip)"
                            [removable]="true"
                            [selectable]="true">
                            {{ workgroupChip }}
                            <mat-icon matChipRemove svgIcon="cross"></mat-icon>
                          </mat-chip-row>
                        }
                        <input
                          #workgroupsAssociateChipInput
                          (matChipInputTokenEnd)="blurAllChipsList()"
                          [formControl]="workgroupsAssociateCtrl"
                          [matAutocomplete]="workgroupsAssociate"
                          [matChipInputAddOnBlur]="false"
                          [matChipInputFor]="workgroupsAssociateChipList"
                          [matChipInputSeparatorKeyCodes]="workgroupsAssociateSeparatorKeysCodes"
                          />
                        </mat-chip-grid>
                        <mat-autocomplete #workgroupsAssociate="matAutocomplete"
                          (optionSelected)="workgroupToAssociateSelected($event)">
                          @for (workgroupChip of workgroupsAssociateFilteredChips | async; track workgroupChip) {
                            <mat-option appAriaTitle
                              [value]="workgroupChip.workgroupname">
                              {{ workgroupChip.workgroupname }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    }
                    @if (displayFilter('workgroupAssociate') || displayFilter('groupAssociate')) {
                      <button (click)="associateToLearners()"
                        class="groups-list__associate-button"
                        data-e2e="group-list-associate-to-learner"
                        [disabled]="isSelectionActionIsEnabled() === false"
                        aria-label="associate"
                        mat-raised-button>
                        <span>{{ 'groups-management.associate_to_learner' | translate }}</span>
                      </button>
                    }
                  }
                  @if (isFiltersCollapsable) {
                    <button (click)="showHideFields()" class="btn-collapse" data-e2e="group-list-show-hide-fields">
                      <span>{{ (filtersExpanded ? 'filters.button.collapse' : 'filters.button.expand') | translate }}</span>
                      <mat-icon [svgIcon]="filtersExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"
                      class="collapsable-arrow"></mat-icon>
                    </button>
                  }
                </mat-toolbar-row>
              </mat-toolbar>
  }
    @if (isMobileView) {
      <div class="groups-list__mobile"
          [@animateStagger]="{value:'50'}">
          @if (empty) {
            <div class="groups-list__mobile-empty">
              @if (type==='class' && authService.isGAR()) {
                <p>{{ 'groups-management.empty_learners_gar' | translate }}</p>
              }
              @if (type==='class' && !authService.isGAR()) {
                <p>{{ 'generic.empty_groups_not_gar' | translate }}</p>
              }
              @if (type === 'group') {
                <p>{{ 'groups-management.empty_groups' | translate }}</p>
              }
              @if (type === 'learner') {
                <p>{{ termInRegardOfGarOrNot | translate }}</p>
              }
            </div>
          }

          @for (entity of mobileEntities; track entity.id; let i = $index) {
            <article class="groups-list__mobile-card"
              [@animate]="{value:'*',params:{y:'100%'}}"
              [ngClass]="{
                'selected': checkboxes[entity.id],
                'groups-list__mobile-card--learner': type === 'learner'
              }">
              <div class="groups-list__mobile-card-header">
                <div class="groups-list__mobile-card-leading">
                  @if (displayedColumns.includes('avatar') && getMobileAvatar(entity)) {
                    <img alt=""
                      [src]="getMobileAvatar(entity)"
                      class="avatar groups-list__mobile-avatar"/>
                  }

                  @if (displayedColumns.includes('color')) {
                    <div [style.background-color]="getMobileColor(entity)"
                      class="pastille groups-list__mobile-color"></div>
                  }
                </div>

                <div class="groups-list__mobile-card-identity">
                  <h3 class="groups-list__mobile-card-title">{{ getCardTitle(entity) }}</h3>
                  @if (getCardSubtitle(entity)) {
                    <p class="groups-list__mobile-card-subtitle">{{ getCardSubtitle(entity) }}</p>
                  }
                </div>

                <div class="groups-list__mobile-card-actions">
                  @if (canSeeMenu(entity)) {
                    <button
                      (click)="$event.stopPropagation();"
                      [matMenuTriggerFor]="mobileMoreMenu"
                      [attr.aria-label]="('accessibility.aria_more_' + type |translate) + ' ' + currentElementForAriaMore(entity) "
                      [matTooltip]="'activities.lesson.more' | translate"
                      class="groups-list__mobile-menu-trigger"
                      mat-icon-button>
                      <mat-icon svgIcon="submenu"></mat-icon>
                    </button>
                  }

                  @if (displayedColumns.includes('checkbox')) {
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      data-e2e="group-list-mobile-checkbox"
                      class="groups-list__mobile-checkbox"
                      [(ngModel)]="checkboxes[entity.id]">
                    </mat-checkbox>
                  }
                </div>

                <mat-menu #mobileMoreMenu="matMenu">
                  @if (editEntitySettings && editEntitySettings.isAuthorized(entity)) {
                    <button
                      data-e2e="group-list-mobile-more-menu-edit"
                      (click)="editEntityFromMobileMenu(entity, i)"
                      aria-label="edit"
                      mat-menu-item>
                      <mat-icon svgIcon="edit"></mat-icon>
                      <span>{{ 'generic.modify' | translate }}</span>
                    </button>
                  }
                  @if (archiveEntitySettings && archiveEntitySettings.isAuthorized(entity) && canArchive && !isMobileArchived(entity)) {
                    <button
                      (click)="archiveEntityFromMobileMenu(entity)"
                      aria-label="archive"
                      mat-menu-item>
                      <mat-icon>archive</mat-icon>
                      <span>{{ 'generic.archive' | translate }}</span>
                    </button>
                  }
                  @if (dearchiveEntitySettings && dearchiveEntitySettings.isAuthorized(entity) && canArchive && isMobileArchived(entity)) {
                    <button
                      (click)="deArchiveEntityFromMobileMenu(entity)"
                      aria-label="dearchive"
                      mat-menu-item>
                      <mat-icon>archive</mat-icon>
                      <span>{{ 'generic.unarchive' | translate }}</span>
                    </button>
                  }
                  @if (activateMetacognitionEntitySettings && activateMetacognitionEntitySettings.isAuthorized(entity) && !isMobileMetacognitionActive(entity) && canActiveMetacognition()) {
                    <button
                      (click)="activateMetacognitionEntityFromMobileMenu(entity)"
                      aria-label="activateMetacognition"
                      mat-menu-item>
                      <mat-icon>edit</mat-icon>
                      <span>{{ 'generic.activateMetacognition' | translate }}</span>
                    </button>
                  }
                  @if (deactivateMetacognitionEntitySettings && deactivateMetacognitionEntitySettings.isAuthorized(entity) && isMobileMetacognitionActive(entity) && canActiveMetacognition()) {
                    <button
                      (click)="deactivateMetacognitionEntityFromMobileMenu(entity)"
                      aria-label="deactivateMetacognition"
                      mat-menu-item>
                      <mat-icon>edit</mat-icon>
                      <span>{{ 'generic.deactivateMetacognition' | translate }}</span>
                    </button>
                  }
                  @if (deleteEntitySettings && deleteEntitySettings.isAuthorized(entity) && deleteLearner) {
                    <button
                      (click)="deleteEntityFromMobileMenu(entity)"
                      aria-label="remove"
                      mat-menu-item>
                      <mat-icon svgIcon="delete"></mat-icon>
                      <span>{{ 'generic.delete' | translate }}</span>
                    </button>
                  }
                  @for (action of getCustomActionsKeyToShow(entity); track action) {
                    <button (click)="execCustomActionsFromMobileMenu(customActions[action], entity)"
                      mat-menu-item>
                      @if (customActions[action].icon) {
                        <mat-icon svgIcon="{{customActions[action].icon}}"></mat-icon>
                      }
                      <span>{{ customActions[action].label | translate }}</span>
                    </button>
                  }
                </mat-menu>
              </div>

              <div class="groups-list__mobile-card-body"
                [ngClass]="{'groups-list__mobile-card-body--expandable': displayedColumns.includes('expandRow') && canExpand(entity) && authService.accessLevel !== 'learner'}"
                (click)="displayedColumns.includes('expandRow') && canExpand(entity) && authService.accessLevel !== 'learner' ? toggleMobileEntityLearnerRow($event, entity, i) : null">
                @for (column of mobileColumns; track column) {
                  @if (shouldDisplayMobileField(entity, column)) {
                    <div class="groups-list__mobile-field">
                      <span class="groups-list__mobile-field-label">{{ getMobileColumnLabel(column) | translate }}</span>

                      @if (column === 'parentalConsent') {
                        <mat-checkbox
                          data-e2e="group-list-mobile-parental-consent"
                          [ngModel]="getMobileParentalConsent(entity)"
                          [disabled]="true">
                        </mat-checkbox>
                      } @else if (column === 'results') {
                        <button
                          (click)="navigateToResult(entity)"
                          class="groups-list__mobile-inline-action"
                          [attr.aria-label]="('accessibility.aria_result' |translate) + ' ' + currentElementForAriaMore(entity)"
                          mat-stroked-button>
                          <mat-icon svgIcon="analytics"></mat-icon>
                        </button>
                      } @else if (column === 'assignation_tab_results') {
                        <button
                          (click)="navigateToAssignationTabResult(entity)"
                          class="groups-list__mobile-inline-action"
                          mat-stroked-button>
                          <mat-icon svgIcon="bar_chart"></mat-icon>
                          <span>{{ 'groups-management.results' | translate }}</span>
                        </button>
                      } @else if (column === 'metacognitionState') {
                        <span class="groups-list__mobile-metacognition">
                          <span [ngClass]="isMobileMetacognitionActive(entity) ? 'metacognitionActivated' : 'metacognitionDeactivated'"></span>
                          <span>
                            {{ (isMobileMetacognitionActive(entity) ? 'generic.metacognition.activated' : 'generic.metacognition.deactivated') | translate }}
                          </span>
                        </span>
                      } @else if (isMobileChipColumn(column)) {
                        <span class="groups-list__mobile-chip">{{ getMobileColumnValue(entity, column) }}</span>
                      } @else if (column === 'groups' && !getMobileColumnValue(entity, column) && editEntitySettings && editEntitySettings.isAuthorized(entity) && isAssignButtonInGroupListMustBeDisplayed()) {
                        <button mat-stroked-button
                          class="btn-assign-only"
                          (click)="openAssignGroups(entity, true)">
                          <span>{{ 'generic.assign'|translate }}</span>
                        </button>
                      } @else {
                        <span class="groups-list__mobile-field-value">{{ getMobileColumnValue(entity, column) }}</span>
                      }
                    </div>
                  }
                }
              </div>

              @if (displayedColumns.includes('expandRow') && canExpand(entity) && authService.accessLevel !== 'learner') {
                <div class="groups-list__mobile-card-footer"
                  (click)="toggleMobileEntityLearnerRow($event, entity, i)">
                  <mat-icon
                    class="groups-list__mobile-expand-icon"
                    [ngClass]="{'groups-list__mobile-expand-icon--open': isOpenAddingLearnerRow(i)}"
                    [svgIcon]="'keyboard_arrow_up'">
                  </mat-icon>
                </div>
              }

              @if (!showGlobalAddButton && isEditingRow(i, entity)) {
                <div class="groups-list__mobile-expanded-content">
                  <app-groups-inline-modal (saveInProgress)="saveInProgress()"
                    (savedOrCancelOccured)="resetIndexEditedRow()"
                    [addEntity]="editedValue(entity)"
                    [ngClass]="specificClassToEdit(entity)"
                    class="groups-inline-modal">
                  </app-groups-inline-modal>
                </div>
              }

              @if (isOpenAddingLearnerRow(i)) {
                <div class="groups-list__mobile-expanded-content">
                  <app-learner class="groups-inline-modal-learner"
                    [groupNameClassroomSelected]="groupnameFilter"
                    [groupNameSelected]="workgroupnameFilter"
                    [isAddingInlineLearnerRowAddButton]="true"
                    [isAddingInlineLearnerRow]="true"
                    [isAddingLearnerFromGroupOrWorkgroup]="addingLearnerRow !== -2">
                  </app-learner>
                </div>
              }
            </article>
          }
      </div>
    }

    @if (!isMobileView) {
      <div id="groups-list-table"
        class="groups-list__table-wrapper content"
        fxFlex
        fxLayout="column"
        fxLayoutAlign="{{align}}"
        fusePerfectScrollbar>
        <table class="groups-list__table"
          mat-table
          [dataSource]="dataSource"
          [@animateStagger]="{value:'50'}"
          #table>

        <caption class="visually-hidden">
          {{ captionInfo | translate }} {{ this.groupNameClassroomSelected }}
        </caption>

        <!-- TODO Lister tous les champs qu'on peut vouloir afficher -->

        <!-- Checkbox Column -->
        <ng-container matColumnDef="checkbox">
          <th *matHeaderCellDef mat-header-cell>
            <mat-checkbox (change)="updateCheck($event)" [(ngModel)]="selectAll" data-e2e="group-list-parental-all"></mat-checkbox>
          </th>
          <td *matCellDef="let entity" mat-cell>
            <mat-checkbox
              (click)="$event.stopPropagation()"
              data-e2e="group-list-parental-id"
              [(ngModel)]="checkboxes[entity.id]">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
          <th *matHeaderCellDef mat-header-cell>{{ 'generic.avatar' | translate }}<span
          class="th__span--hidden-accessibility">{{ 'accessibility.th_hidden_avatar' | translate }}</span>
        </th>
        <td *matCellDef="let entity" mat-cell>
          @if (entity.avatar) {
            <img alt="" [src]="entity.avatar"
              class="avatar"/>
          }
        </td>
      </ng-container>

      <!-- Color Column -->
      <ng-container matColumnDef="color">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.color' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <div [style.background-color]="entity.color" class="pastille"></div>
        </td>
      </ng-container>

      <!-- nickname Column -->
      <ng-container matColumnDef="nickname">
        <th *matHeaderCellDef mat-header-cell>{{ 'account-management.pseudo' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.nickname }}</p>
        </td>
      </ng-container>

      <!-- pseudo Column -->
      <!-- TODO: we use this field "pseudo" and not "username" because we need another name for this field, we cant use another translated term, need to find better fix -->
      <ng-container matColumnDef="pseudo">
        <th *matHeaderCellDef mat-header-cell>
          @if (authService.isGAR()) {
            {{ 'groups-management.nickname_GAR' | translate }}
          }
          @if (!authService.isGAR()) {
            {{ 'groups-management.nickname' | translate }}
          }
        </th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.username }}</p>
        </td>
      </ng-container>

      <!-- Username Column -->
      <ng-container matColumnDef="username">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_students' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.username }}</p>
        </td>
      </ng-container>


      <!-- Trainer username Column -->
      <ng-container matColumnDef="trainer-name">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_trainers' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.username }}</p>
        </td>
      </ng-container>


      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th *matHeaderCellDef fxHide fxShow.gt-sm mat-header-cell>Email</th>
        <td *matCellDef="let entity" fxHide fxShow.gt-sm mat-cell>
          <p class="email text-truncate">
            {{ entity.email }}
          </p>
        </td>
      </ng-container>

      <!-- codeid Column -->
      <ng-container matColumnDef="codeid">
        <th *matHeaderCellDef mat-header-cell>{{ 'account-management.codeid' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.codeid }}</p>
        </td>
      </ng-container>

      <!-- Type Trainer Column -->
      <ng-container matColumnDef="type">
        <th *matHeaderCellDef mat-header-cell>Type</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ getTranslate(entity.type) | translate }}</p>
        </td>
      </ng-container>

      <!-- Date Trainer Column -->
      <ng-container matColumnDef="access">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.date_last_connection' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.access }}</p>
        </td>
      </ng-container>

      <!-- Institution Group Column -->
      <ng-container matColumnDef="institutiongroupname">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.institution' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.institutiongroupname }}</p>
        </td>
      </ng-container>

      <!-- Group Column -->
      <ng-container matColumnDef="groupname">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.label_group' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.groupname }}</p>
        </td>
      </ng-container>

      <!-- Workgroup Column -->
      <ng-container matColumnDef="workgroupname">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.group' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.workgroupname }}</p>
        </td>
      </ng-container>

      <!-- Groups Column -->
      <ng-container matColumnDef="groups">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_classes' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          @if (entity.groups?.length) {
            <p class="text-truncate">{{ entity.groups.join(', ') }}</p>
          }
          @if (!entity.groups?.length && editEntitySettings && editEntitySettings.isAuthorized(entity) && isAssignButtonInGroupListMustBeDisplayed()) {
            <button mat-raised-button class="btn-assign-only"
              (click)="openAssignGroups(entity, true)">
              <span>{{ 'generic.assign'|translate }}</span>
            </button>
          }
        </td>
      </ng-container>

      <!-- Workgroups Column -->
      <ng-container matColumnDef="workgroups">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_workgroups' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          @if (entity.workgroups?.length) {
            <p class="text-truncate">{{ entity.workgroups.join(', ') }}</p>
          }
        </td>
      </ng-container>

      <!-- Checkbox Parental consent Column -->
      <ng-container matColumnDef="parentalConsent">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.parental_consent' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <mat-checkbox
              data-e2e="group-list-parental-consent"
            [(ngModel)]="entity.parentalConsent"
            [disabled]="true"
            >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- result Column -->
      <ng-container matColumnDef="results">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.results' | translate }}</th>
        <td (click)="navigateToResult(entity)" [attr.aria-label]="('accessibility.aria_result' |translate) + ' ' + currentElementForAriaMore(entity)" *matCellDef="let entity" mat-cell>
          <mat-icon svgIcon="analytics"></mat-icon>
        </td>
      </ng-container>

      <!-- assignation tab result Column -->
      <ng-container matColumnDef="assignation_tab_results">
        <th *matHeaderCellDef
          mat-header-cell>
          <span class="th__span--hidden-accessibility">{{ 'accessibility.th_hidden_char' | translate }}</span>
        </th>
        <td *matCellDef="let entity"
          mat-cell
          >
          <mat-icon svgIcon="bar_chart"
            tabindex="0"
            role="button"
            (click)="navigateToAssignationTabResult(entity)"
            (keydown.enter)="navigateToAssignationTabResult(entity)"
          ></mat-icon>
        </td>
      </ng-container>

      <!-- Learners Column -->
      <ng-container matColumnDef="learners">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.number_of_student' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.learners }}</p>
        </td>
      </ng-container>

      <!-- Learners List Column -->
      <ng-container matColumnDef="learnerslist">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_students' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p>{{ entity.learners.join(', ') }}</p>
        </td>
      </ng-container>

      <!-- Level Column utilisé pour age-->
      <ng-container matColumnDef="level">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.level' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ formatLevel(entity.level) }}</p>
        </td>
      </ng-container>

      <!--school year-->
      <ng-container matColumnDef="schoolyear">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.school.year' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          @if (entity.schoolyear_term) {
            <p
            class="text-truncate">{{ groupsManagementService.displaySchoolYear(entity.schoolyear_term.name) }}</p>
          }
          @if (!entity.schoolyear_term) {
            <p class="text-truncate">not set</p>
          }
        </td>
      </ng-container>

      <!-- Code Column -->
      <ng-container matColumnDef="code">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.code_class' | translate }}</th>
        <td *matCellDef="let entity" [ngClass]="{ 'disabled' : isCodeClassDisabled() }" mat-cell>
          <p class="text-truncate">{{ entity.code }}</p>
        </td>
      </ng-container>

      <!-- Institution Group Column address-->
      <ng-container matColumnDef="address">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.address' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.address }}</p>
        </td>
      </ng-container>

      <!-- Institution Group Column code postal-->
      <ng-container matColumnDef="postalCode">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.postal-code' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.postalCode }}</p>
        </td>
      </ng-container>

      <!-- Institution Group Column city-->
      <ng-container matColumnDef="city">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.city' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.city }}</p>
        </td>
      </ng-container>

      <!-- Institution Group Column country-->
      <ng-container matColumnDef="country">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.country' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.country }}</p>
        </td>
      </ng-container>


      <!-- Institutions Column -->
      <ng-container matColumnDef="institutions">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.my_institution' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.parent?.label }}</p>
        </td>
      </ng-container>


      <!-- trainer Institutions Column -->
      <ng-container matColumnDef="trainer-institutions">
        <th *matHeaderCellDef mat-header-cell>{{ 'groups-management.institution' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <p class="text-truncate">{{ entity.institution }}</p>
        </td>
      </ng-container>

      <!-- metacognitionState Column -->
      <ng-container matColumnDef="metacognitionState">
        <th *matHeaderCellDef mat-header-cell>{{ 'generic.metacognition' | translate }}</th>
        <td *matCellDef="let entity" mat-cell>
          <div [ngClass]="entity.metacognitionActive ? 'metacognitionActivated' : 'metacognitionDeactivated'">
          </div>
          <span>
            {{ (entity.metacognitionActive ? 'generic.metacognition.activated' : 'generic.metacognition.deactivated') | translate }}
          </span>
        </td>
      </ng-container>

      <!--expand Column-->
      <ng-container matColumnDef="expandRow">
        <th *matHeaderCellDef mat-header-cell><span
        class="th__span--hidden-accessibility">{{ 'accessibility.th_hidden_collapse' | translate }}</span>
      </th>
      <td *matCellDef="let entity; let i = index" mat-cell>
        @if (canExpand(entity)) {
          <mat-icon
            class="collapsable-arrow"
            [svgIcon]="isOpenAddingLearnerRow(i) ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"
            tabindex="0"
            role="button"
            aria-hidden="false"
            [attr.aria-expanded]="isOpenAddingLearnerRow(i)"
            [attr.aria-label]="((isOpenAddingLearnerRow(i)?'accessibility.group_collapse_learners':'accessibility.group_expand_learners') | translate) + (entity?.groupname? ' ' +entity?.groupname:'')"
            (click)="onArrowAction($event, i)"
            (keyup.enter)="onArrowAction($event, i)">
          </mat-icon>
        }
      </td>
    </ng-container>

    <!-- Buttons Column -->
    <ng-container matColumnDef="buttons">
      <th *matHeaderCellDef mat-header-cell><span
      class="th__span--hidden-accessibility">{{ 'accessibility.th_hidden_more_menu' | translate }}</span>
    </th>
    <td *matCellDef="let entity let i = index" mat-cell>
      <!-- TODO - Add settings for access management -->
      @if (canSeeMenu(entity)) {
        <div>
          <button
            (click)="$event.stopPropagation();"
            [matMenuTriggerFor]="moreMenu"
            data-e2e="group-list-more-menu"
            [attr.aria-label]="('accessibility.aria_more_' + type |translate) + ' ' + currentElementForAriaMore(entity) "
            [matTooltip]="'activities.lesson.more' | translate"
            mat-icon-button>
            <mat-icon svgIcon="submenu"></mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            @if (editEntitySettings && editEntitySettings.isAuthorized(entity)) {
              <button
                data-e2e="group-list-more-menu-edit"
                (click)="editEntity(entity, i)"
                aria-label="edit"
                mat-menu-item>
                <mat-icon svgIcon="edit"></mat-icon>
                <span>{{ 'generic.modify' | translate }}</span>
              </button>
            }
            @if (archiveEntitySettings && archiveEntitySettings.isAuthorized(entity) && canArchive && !entity.archived) {
              <button
                (click)="archiveEntity(entity)"
                data-e2e="group-list-more-archive"
                aria-label="archive"
                mat-menu-item>
                <mat-icon>archive</mat-icon>
                <span>{{ 'generic.archive' | translate }}</span>
              </button>
            }
            @if (dearchiveEntitySettings && dearchiveEntitySettings.isAuthorized(entity) && canArchive && entity.archived) {
              <button
                (click)="deArchiveEntity(entity)"
                aria-label="dearchive"
                data-e2e="group-list-more-menu-dearchive"
                mat-menu-item>
                <mat-icon>archive</mat-icon>
                <span>{{ 'generic.unarchive' | translate }}</span>
              </button>
            }
            @if (activateMetacognitionEntitySettings && activateMetacognitionEntitySettings.isAuthorized(entity) && !entity.metacognitionActive && canActiveMetacognition()) {
              <button
                (click)="activateMetacognitionEntity(entity)"
                aria-label="activateMetacognition"
                data-e2e="group-list-more-menu-activate-meta"
                mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>{{ 'generic.activateMetacognition' | translate }}</span>
              </button>
            }
            @if (deactivateMetacognitionEntitySettings && deactivateMetacognitionEntitySettings.isAuthorized(entity) && entity.metacognitionActive && canActiveMetacognition()) {
              <button
                (click)="deactivateMetacognitionEntity(entity)"
                aria-label="deactivateMetacognition"
                mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>{{ 'generic.deactivateMetacognition' | translate }}</span>
              </button>
            }
            @if (deleteEntitySettings && deleteEntitySettings.isAuthorized(entity) && deleteLearner) {
              <button
                (click)="deleteEntity(entity)"
                aria-label="remove"
                data-e2e="group-list-more-menu-delete"
                mat-menu-item>
                <mat-icon svgIcon="delete"></mat-icon>
                <span>{{ 'generic.delete' | translate }}</span>
              </button>
            }
            @for (action of getCustomActionsKeyToShow(entity); track action) {
              <button (click)="execCustomActions(customActions[action], entity)"
                mat-menu-item
                [attr.data-e2e]="'group-list-more-menu-actions' + customActions[action].label">
                @if (customActions[action].icon) {
                  <mat-icon
                  svgIcon="{{customActions[action].icon}}"></mat-icon>
                }
                <span>{{ customActions[action].label | translate }}</span>
              </button>
            }
          </mat-menu>
        </div>
      }

    </td>
    </ng-container>

    <!--use for inline editing-->
    <ng-container class="mat-row-editing" matColumnDef="editing">
    <td *matCellDef="let item" [attr.colspan]="displayedColumns.length" mat-cell>
      @if (!showGlobalAddButton) {
        <app-groups-inline-modal (saveInProgress)="saveInProgress()"
          (savedOrCancelOccured)="resetIndexEditedRow()"
          [addEntity]="editedValue(item)"
          [ngClass]="specificClassToEdit(item)"
          class="groups-inline-modal">
        </app-groups-inline-modal>
      }
    </td>
    </ng-container>

    <!--use for show app-learner inside a row-->
    <ng-container class="mat-row-editing"
    matColumnDef="addingLearner">
    <td mat-cell
      *matCellDef="let item"
      [attr.colspan]="displayedColumns.length">
      <app-learner class="groups-inline-modal-learner"
        [groupNameClassroomSelected]="groupnameFilter"
        [groupNameSelected]="workgroupnameFilter"
        [isAddingInlineLearnerRowAddButton]="true"
        [isAddingInlineLearnerRow]="true"
        [isAddingLearnerFromGroupOrWorkgroup]="addingLearnerRow !== -2">
      </app-learner>
    </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr class="mat-mdc-row"
    *matNoDataRow>
    @if (type==='class' && authService.isGAR()) {
      <td class="mat-cell"
        [attr.colspan]="displayedColumns.length">{{ 'groups-management.empty_learners_gar' | translate }}
      </td>
    }
    @if (type==='class' && !authService.isGAR()) {
      <td class="mat-cell"
        [attr.colspan]="displayedColumns.length">{{ 'generic.empty_groups_not_gar' | translate }}
      </td>
    }
    @if (type === 'group') {
      <td class="mat-cell"
        [attr.colspan]="displayedColumns.length">{{ 'groups-management.empty_groups' | translate }}
      </td>
    }
    @if (type === 'learner') {
      <td class="mat-cell"
        [attr.colspan]="displayedColumns.length">{{ termInRegardOfGarOrNot | translate }}
      </td>
    }
    </tr>
    <tr (click)="editEntity(entity, i, true)"
    (keyup.enter)="editEntity(entity, i, true)"
    data-e2e="group-list-row-edit-entity"
    *matRowDef="let entity; columns: displayedColumns;let i = index;"
    [@animate]="{value:'*',params:{y:'100%'}}"
    [ngClass]="{'selected':checkboxes[entity.id]}"
    class="entity"
    mat-row
    matRipple>
    </tr>
    <!--if row is editing it will show this specific-->
    <tr *matRowDef="let row; columns: ['editing']; when: isEditingRow;" class="mat-row-editing" mat-row></tr>
    <!--if adding student zone is activated will show row and adding row zone-->
    <tr *matRowDef="let row; columns: ['addingLearner']; when: isAddingLearnerRow;" class="mat-row-editing"
    mat-row></tr>
        </table>

      </div>
    }
      <!--component for adding element inline instead of with an opening modal-->
      @if (!showGlobalAddButton && isAddingInlineLearnerRowAddButton && this.authService.accessLevel!=='learner') {
        <app-groups-inline-modal
          class="groups-inline-modal add-edit"
          [ngClass]="specificClassToEdit(addEntity)"
          [addEntity]="addEntity"
          [groupNameClassroomSelected]="groupNameClassroomSelected"
          [groupNameSelected]="groupNameSelected"
          [isAddingLearnerFromGroupOrWorkgroup]="isAddingLearnerFromGroupOrWorkgroup"
          [joinLearner]="getJoinLearnerForThisGroup()"
          [learnersList]="learnersList"
          (savedOrCancelOccured)="manageAddLearnerOpenedLine()">
        </app-groups-inline-modal>
      }

</div>